module.exports = __webpack_public_path__ + "static/media/Marston Ave, San Francisco, CA3.7fc4f517.jpg";